import { useEffect } from "react";

import i18n from "../libs/i18n/i18n";

export const useLanguageDetect = () => {
  useEffect(() => {
    if (window.AP) {
      window?.AP?.user?.getLocale((loc) => {
        const locale = loc.replace("_", "-");
        if (!locale) return;
        i18n.changeLanguage(locale.split("-")[0]);
      });
    }
  }, [window.AP]);
};
